import Title from './Title'

export default Title
// eslint-disable-next-line import/export
export * from './Title'
